/* eslint-disable max-len */

import { get } from '../utils/api';
import {
  buildGetUrlWithHudCompletedTab,
  getHudCompletedTabParamsFromOptions,
} from '../containers/GeneralAffordable/isHudCompletedTab';

export default class HouseholdProfileService {
  getHouseholdProfileAffordableQualificationsByProgram(
    organizationId: string,
    propertyId: string,
    householdId: string,
    programId: string,
  ) {
    return get(
      `/${organizationId}/${propertyId}/household-profile/${householdId}/property-affordable-programs/${programId}/qualifications`,
    );
  }

  getHouseholdApplicantAffordableQualificationChecklist(
    organizationId: string,
    propertyId: string,
    householdId: string,
    applicantId: string,
    options?: Object,
  ) {
    const { isHudCompletedTab, affordableQualificationId, fetchOptions } =
      getHudCompletedTabParamsFromOptions(options);
    const url = buildGetUrlWithHudCompletedTab(
      `/${organizationId}/${propertyId}/households/${householdId}/applicants/${applicantId}/affordable-qualification-checklist`,
      {
        isHudCompletedTab,
        affordableQualificationId,
      },
    );
    return get(url, fetchOptions);
  }
}
